import { render, staticRenderFns } from "./ExpandablePriceInfo.vue?vue&type=template&id=2dec2e50&scoped=true"
import script from "./ExpandablePriceInfo.vue?vue&type=script&lang=ts"
export * from "./ExpandablePriceInfo.vue?vue&type=script&lang=ts"
import style0 from "./ExpandablePriceInfo.vue?vue&type=style&index=0&id=2dec2e50&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dec2e50",
  null
  
)

export default component.exports